module.exports = __webpack_public_path__ + "static/img/aiBag.810fbeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ai_beauty/aiBag.png
// module id = gZXT
// module chunks = 1